module.exports = __webpack_public_path__ + "static/media/newTask.cfae92b8.svg";